import React from "react";
import AppUrlParams from "../models/appUrlParams";

const AppUrlParamsContext = React.createContext<AppUrlParams>(
  new AppUrlParams()
);
AppUrlParamsContext.displayName = "AppUrlParams";

export default AppUrlParamsContext;
